"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetScanVisibilityResult = exports.GetCodeScansResult = exports.CodeScanRow = exports.CreateAnalyticsViewResult = exports.CreateAnalyticsViewPayload = exports.GetAnalyticsViewsResult = exports.AnalyticsView = exports.MutateAnalyticsPeriodResult = exports.UpdateAnalyticsPeriodPayload = exports.CreateAnalyticsPeriodPayload = exports.GetAnalyticsPeriodsResult = exports.AnalyticsPeriod = exports.GetAnalyticsWindowResult = exports.AnalyticsWindow = exports.AnalyticsWindowTagStat = exports.AnalyticsWindowPeriodStat = exports.AnalyticsWindowPlace = exports.AnalyticsWindowCode = exports.AnalyticsWindowAction = exports.AnalyticsWindowDay = exports.GetAnalyticsWindowParams = exports.AnalyticsWindowPeriodDef = exports.GetOrganizationScanTotalsResult = exports.ConstellationScanTotals = exports.GetScanPlacesResult = exports.ScanPlace = exports.GetDailyScansResult = exports.DailyScanPoint = exports.GetHourlyScansResult = exports.HourlyScanPoint = exports.GetScanSummaryResult = exports.ScanSummary = void 0;
const class_validator_1 = require("class-validator");
const base_get_result_dto_1 = require("../../../../common/dtos/base-get-result.dto");
/** The headline numbers on the control panel. */
class ScanSummary {
}
__decorate([
    (0, class_validator_1.IsNumber)()
], ScanSummary.prototype, "today", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], ScanSummary.prototype, "yesterday", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], ScanSummary.prototype, "last7Days", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], ScanSummary.prototype, "last30Days", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], ScanSummary.prototype, "lifetime", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], ScanSummary.prototype, "lastScanAt", void 0);
exports.ScanSummary = ScanSummary;
class GetScanSummaryResult extends base_get_result_dto_1.BaseGetResult {
}
__decorate([
    (0, class_validator_1.IsObject)()
], GetScanSummaryResult.prototype, "summary", void 0);
exports.GetScanSummaryResult = GetScanSummaryResult;
/** One bucket of the day, 0..23, in the requested time zone. */
class HourlyScanPoint {
}
__decorate([
    (0, class_validator_1.IsNumber)()
], HourlyScanPoint.prototype, "hour", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], HourlyScanPoint.prototype, "scans", void 0);
exports.HourlyScanPoint = HourlyScanPoint;
class GetHourlyScansResult extends base_get_result_dto_1.BaseGetResult {
}
__decorate([
    (0, class_validator_1.IsArray)()
], GetHourlyScansResult.prototype, "hours", void 0);
exports.GetHourlyScansResult = GetHourlyScansResult;
class DailyScanPoint {
}
__decorate([
    (0, class_validator_1.IsString)()
], DailyScanPoint.prototype, "date", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], DailyScanPoint.prototype, "scans", void 0);
exports.DailyScanPoint = DailyScanPoint;
class GetDailyScansResult extends base_get_result_dto_1.BaseGetResult {
}
__decorate([
    (0, class_validator_1.IsArray)()
], GetDailyScansResult.prototype, "days", void 0);
exports.GetDailyScansResult = GetDailyScansResult;
class ScanPlace {
}
__decorate([
    (0, class_validator_1.IsString)()
], ScanPlace.prototype, "city", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], ScanPlace.prototype, "region", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], ScanPlace.prototype, "scans", void 0);
exports.ScanPlace = ScanPlace;
class GetScanPlacesResult extends base_get_result_dto_1.BaseGetResult {
}
__decorate([
    (0, class_validator_1.IsArray)()
], GetScanPlacesResult.prototype, "places", void 0);
exports.GetScanPlacesResult = GetScanPlacesResult;
/** Per-code totals for a whole organization, in one request. */
class ConstellationScanTotals {
}
__decorate([
    (0, class_validator_1.IsString)()
], ConstellationScanTotals.prototype, "constellationId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], ConstellationScanTotals.prototype, "last7Days", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], ConstellationScanTotals.prototype, "last30Days", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], ConstellationScanTotals.prototype, "lifetime", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], ConstellationScanTotals.prototype, "lastScanAt", void 0);
exports.ConstellationScanTotals = ConstellationScanTotals;
/**
 * The grid renders `scans7d` on every card, so fetching it per code would be an
 * N+1 across the whole organization — 500 requests to draw one screen.
 */
class GetOrganizationScanTotalsResult extends base_get_result_dto_1.BaseGetResult {
}
__decorate([
    (0, class_validator_1.IsArray)()
], GetOrganizationScanTotalsResult.prototype, "totals", void 0);
exports.GetOrganizationScanTotalsResult = GetOrganizationScanTotalsResult;
/* ---------------------------------------------------------------------------
 * The analytics WINDOW — one filtered aggregation of an organization's scans.
 *
 * The dashboard's lens (timeframe + weekday mask + code/period filters +
 * comparisons) is assembled CLIENT-side from one or more windows: the current
 * frame, the frame before it, and one per comparison segment. The server's
 * job is exact counting over the events tables; the client's is arranging
 * the counts into the lens's view model. Periods are sent as definitions
 * because they live client-side today — the server evaluates, it does not
 * store.
 * ------------------------------------------------------------------------ */
class AnalyticsWindowPeriodDef {
}
__decorate([
    (0, class_validator_1.IsString)()
], AnalyticsWindowPeriodDef.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], AnalyticsWindowPeriodDef.prototype, "weekday", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], AnalyticsWindowPeriodDef.prototype, "startMinutes", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], AnalyticsWindowPeriodDef.prototype, "endMinutes", void 0);
exports.AnalyticsWindowPeriodDef = AnalyticsWindowPeriodDef;
class GetAnalyticsWindowParams {
}
__decorate([
    (0, class_validator_1.IsString)()
], GetAnalyticsWindowParams.prototype, "tz", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], GetAnalyticsWindowParams.prototype, "days", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], GetAnalyticsWindowParams.prototype, "endDaysAgo", void 0);
__decorate([
    (0, class_validator_1.IsArray)()
], GetAnalyticsWindowParams.prototype, "weekdays", void 0);
__decorate([
    (0, class_validator_1.IsArray)()
], GetAnalyticsWindowParams.prototype, "codeIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)()
], GetAnalyticsWindowParams.prototype, "periodIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)()
], GetAnalyticsWindowParams.prototype, "tags", void 0);
exports.GetAnalyticsWindowParams = GetAnalyticsWindowParams;
class AnalyticsWindowDay {
}
__decorate([
    (0, class_validator_1.IsString)()
], AnalyticsWindowDay.prototype, "date", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], AnalyticsWindowDay.prototype, "scans", void 0);
exports.AnalyticsWindowDay = AnalyticsWindowDay;
class AnalyticsWindowAction {
}
__decorate([
    (0, class_validator_1.IsString)()
], AnalyticsWindowAction.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], AnalyticsWindowAction.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], AnalyticsWindowAction.prototype, "constellationId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], AnalyticsWindowAction.prototype, "scans", void 0);
__decorate([
    (0, class_validator_1.IsArray)()
], AnalyticsWindowAction.prototype, "daily", void 0);
exports.AnalyticsWindowAction = AnalyticsWindowAction;
class AnalyticsWindowCode {
}
__decorate([
    (0, class_validator_1.IsString)()
], AnalyticsWindowCode.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], AnalyticsWindowCode.prototype, "scans", void 0);
exports.AnalyticsWindowCode = AnalyticsWindowCode;
class AnalyticsWindowPlace {
}
__decorate([
    (0, class_validator_1.IsString)()
], AnalyticsWindowPlace.prototype, "city", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], AnalyticsWindowPlace.prototype, "region", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], AnalyticsWindowPlace.prototype, "scans", void 0);
exports.AnalyticsWindowPlace = AnalyticsWindowPlace;
class AnalyticsWindowPeriodStat {
}
__decorate([
    (0, class_validator_1.IsString)()
], AnalyticsWindowPeriodStat.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], AnalyticsWindowPeriodStat.prototype, "scans", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], AnalyticsWindowPeriodStat.prototype, "prevScans", void 0);
exports.AnalyticsWindowPeriodStat = AnalyticsWindowPeriodStat;
class AnalyticsWindowTagStat {
}
__decorate([
    (0, class_validator_1.IsString)()
], AnalyticsWindowTagStat.prototype, "tag", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], AnalyticsWindowTagStat.prototype, "scans", void 0);
exports.AnalyticsWindowTagStat = AnalyticsWindowTagStat;
class AnalyticsWindow {
}
__decorate([
    (0, class_validator_1.IsNumber)()
], AnalyticsWindow.prototype, "scans", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], AnalyticsWindow.prototype, "uniqueScanners", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], AnalyticsWindow.prototype, "newScanners", void 0);
__decorate([
    (0, class_validator_1.IsArray)()
], AnalyticsWindow.prototype, "daily", void 0);
__decorate([
    (0, class_validator_1.IsArray)()
], AnalyticsWindow.prototype, "actions", void 0);
__decorate([
    (0, class_validator_1.IsArray)()
], AnalyticsWindow.prototype, "codes", void 0);
__decorate([
    (0, class_validator_1.IsArray)()
], AnalyticsWindow.prototype, "places", void 0);
__decorate([
    (0, class_validator_1.IsArray)()
], AnalyticsWindow.prototype, "periods", void 0);
__decorate([
    (0, class_validator_1.IsArray)()
], AnalyticsWindow.prototype, "tags", void 0);
exports.AnalyticsWindow = AnalyticsWindow;
class GetAnalyticsWindowResult extends base_get_result_dto_1.BaseGetResult {
}
__decorate([
    (0, class_validator_1.IsObject)()
], GetAnalyticsWindowResult.prototype, "window", void 0);
exports.GetAnalyticsWindowResult = GetAnalyticsWindowResult;
/* ---------------------------------------------------------------------------
 * Analytics PERIODS — the organization's recurring service-time windows.
 *
 * Org-level configuration, not per-code: "Sunday morning" is the
 * organization's rhythm. Evaluated at query time against each scan's local
 * weekday/minute in the caller's zone.
 * ------------------------------------------------------------------------ */
class AnalyticsPeriod {
}
__decorate([
    (0, class_validator_1.IsString)()
], AnalyticsPeriod.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], AnalyticsPeriod.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], AnalyticsPeriod.prototype, "weekday", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], AnalyticsPeriod.prototype, "startMinutes", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], AnalyticsPeriod.prototype, "endMinutes", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], AnalyticsPeriod.prototype, "position", void 0);
exports.AnalyticsPeriod = AnalyticsPeriod;
class GetAnalyticsPeriodsResult extends base_get_result_dto_1.BaseGetResult {
}
__decorate([
    (0, class_validator_1.IsArray)()
], GetAnalyticsPeriodsResult.prototype, "periods", void 0);
exports.GetAnalyticsPeriodsResult = GetAnalyticsPeriodsResult;
class CreateAnalyticsPeriodPayload {
}
__decorate([
    (0, class_validator_1.IsString)()
], CreateAnalyticsPeriodPayload.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], CreateAnalyticsPeriodPayload.prototype, "weekday", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], CreateAnalyticsPeriodPayload.prototype, "startMinutes", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], CreateAnalyticsPeriodPayload.prototype, "endMinutes", void 0);
exports.CreateAnalyticsPeriodPayload = CreateAnalyticsPeriodPayload;
/** Partial: only the provided fields change. */
class UpdateAnalyticsPeriodPayload {
}
__decorate([
    (0, class_validator_1.IsString)()
], UpdateAnalyticsPeriodPayload.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], UpdateAnalyticsPeriodPayload.prototype, "weekday", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], UpdateAnalyticsPeriodPayload.prototype, "startMinutes", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], UpdateAnalyticsPeriodPayload.prototype, "endMinutes", void 0);
__decorate([
    (0, class_validator_1.IsNumber)()
], UpdateAnalyticsPeriodPayload.prototype, "position", void 0);
exports.UpdateAnalyticsPeriodPayload = UpdateAnalyticsPeriodPayload;
class MutateAnalyticsPeriodResult extends base_get_result_dto_1.BaseGetResult {
}
__decorate([
    (0, class_validator_1.IsObject)()
], MutateAnalyticsPeriodResult.prototype, "period", void 0);
exports.MutateAnalyticsPeriodResult = MutateAnalyticsPeriodResult;
/* ---------------------------------------------------------------------------
 * Analytics VIEWS — saved lenses, routable as reports.
 *
 * `frame` and `filters` are the dashboard's own serialized shapes
 * (`Timeframe`, `AnalyticsFilters`); the server stores them opaquely so the
 * lens grammar can grow without a wire-format change.
 * ------------------------------------------------------------------------ */
class AnalyticsView {
}
__decorate([
    (0, class_validator_1.IsString)()
], AnalyticsView.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], AnalyticsView.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsObject)()
], AnalyticsView.prototype, "frame", void 0);
__decorate([
    (0, class_validator_1.IsObject)()
], AnalyticsView.prototype, "filters", void 0);
exports.AnalyticsView = AnalyticsView;
class GetAnalyticsViewsResult extends base_get_result_dto_1.BaseGetResult {
}
__decorate([
    (0, class_validator_1.IsArray)()
], GetAnalyticsViewsResult.prototype, "views", void 0);
exports.GetAnalyticsViewsResult = GetAnalyticsViewsResult;
class CreateAnalyticsViewPayload {
}
__decorate([
    (0, class_validator_1.IsString)()
], CreateAnalyticsViewPayload.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsObject)()
], CreateAnalyticsViewPayload.prototype, "frame", void 0);
__decorate([
    (0, class_validator_1.IsObject)()
], CreateAnalyticsViewPayload.prototype, "filters", void 0);
exports.CreateAnalyticsViewPayload = CreateAnalyticsViewPayload;
class CreateAnalyticsViewResult extends base_get_result_dto_1.BaseGetResult {
}
__decorate([
    (0, class_validator_1.IsObject)()
], CreateAnalyticsViewResult.prototype, "view", void 0);
exports.CreateAnalyticsViewResult = CreateAnalyticsViewResult;
/* ---------------------------------------------------------------------------
 * The scans LEDGER — every scan of one code, one row each.
 *
 * The row-level control is the point: any scan can be hidden from aggregate
 * analytics (`hidden_by_staff` on `event_test_types` — every aggregate
 * already excludes labelled events, so hiding moves every chart at once).
 * Hidden rows stay in the ledger, marked.
 * ------------------------------------------------------------------------ */
class CodeScanRow {
}
__decorate([
    (0, class_validator_1.IsString)()
], CodeScanRow.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], CodeScanRow.prototype, "at", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], CodeScanRow.prototype, "actionId", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], CodeScanRow.prototype, "actionName", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], CodeScanRow.prototype, "actionType", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], CodeScanRow.prototype, "city", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], CodeScanRow.prototype, "region", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], CodeScanRow.prototype, "device", void 0);
__decorate([
    (0, class_validator_1.IsString)()
], CodeScanRow.prototype, "browser", void 0);
exports.CodeScanRow = CodeScanRow;
class GetCodeScansResult extends base_get_result_dto_1.BaseGetResult {
}
__decorate([
    (0, class_validator_1.IsArray)()
], GetCodeScansResult.prototype, "scans", void 0);
exports.GetCodeScansResult = GetCodeScansResult;
class SetScanVisibilityResult extends base_get_result_dto_1.BaseGetResult {
}
exports.SetScanVisibilityResult = SetScanVisibilityResult;
